import { render, staticRenderFns } from "./purchaseAndSaleFirstDetail.vue?vue&type=template&id=30220c0c&scoped=true"
import script from "./purchaseAndSaleFirstDetail.vue?vue&type=script&lang=js"
export * from "./purchaseAndSaleFirstDetail.vue?vue&type=script&lang=js"
import style0 from "./purchaseAndSaleFirstDetail.vue?vue&type=style&index=0&id=30220c0c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30220c0c",
  null
  
)

export default component.exports